import React, { useContext, useMemo } from "react";
import { Context } from "../../Context/ContextApi";
import HomeSlider from "./HomeSlider";
import Products from "./Products";
import OfferBanner from "./OfferBanner";
import FeaturedPaintings from "./FeaturedPaintings";
import CategorySection from "./CategorySection";

const HomePage = () => {
  const { slide, category } = useContext(Context);

  const sliderData = useMemo(() => slide?.data?.slider ?? [], [slide]);

  return (
    <>
      <HomeSlider sliderData={sliderData} />

      <CategorySection category={category} />

      <Products />
      <OfferBanner />
      <FeaturedPaintings />
    </>
  );
};

export default HomePage;
